<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
    items: Array<{
        title: string,
        desc: string,
    }>
}>();
const facilitieStyles = [
  { state: 'first', vairant: 'primary' },
  { state: 'second', vairant: 'secondary' },
  { state: 'first', vairant: 'white' },
  { state: 'second', vairant: 'blue' },
] as const;
</script>

<template>
    <SectionsBase id="facilities" class="background">
        <div class="container">
            <ChipsDivider>امکانات</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
            <div class="mt-8 lg:mt-24 max-w-full flex flex-col gap-7">
                <div class="w-full flex-center flex-col lg:flex-row gap-7">
                <LazyCardsFeature
                    v-for="feature, index in props.items"
                    :key="feature.title"
                    type="Secondary"
                    :state="facilitieStyles[index]?.state"
                    :vairant="facilitieStyles[index]?.vairant"
                    data-aos="flip-left" 
                    data-aos-duration="1500"
                    :data-aos-delay="index * 150"
                >
                    <div class="flex flex-col items-center gap-7">
                    <h3>{{ feature.title }}</h3>
                    <p v-html="feature.desc" />
                    </div>
                </LazyCardsFeature>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    bg-linear-to-b from-transparent to-primary-50 to-90% relative
}
.background::before {
    @apply
    content-[''] w-full h-full absolute top-0 left-0 bg-[url('/img/new/backgrounds/mesh-04.webp')] opacity-70
}
</style>